var _defs, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoNamecheap = function SvgLogoNamecheap(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 258 46.57",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 59.99,
    y1: 44.16,
    x2: 80.01,
    y2: 1.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4202c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#dc3d29",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e45926",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#ea7123",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f08521",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#f4941f",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f79f1e",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f8a51d",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a71d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1777.48,
    y1: 1048.76,
    x2: 1797.5,
    y2: 1005.83,
    gradientTransform: "translate(1803.5 1052.6) rotate(180)",
    xlinkHref: "#a"
  }))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "cn-logo")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.17.71a7.87,7.87,0,0,0-6.88,4.05l-.16.33L64,17.25l-7.8,15.37,5.11,10.07.28.55A8,8,0,0,0,65,46.47a8.05,8.05,0,0,0,3.41-3.23l.28-.55L84,12.48l.37-.73a7.86,7.86,0,0,0-7.19-11Z",
    transform: "translate(-1 -0.71)",
    fill: "#ff5100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.85,15.34l-5.1-10-.28-.55a7.89,7.89,0,0,0-3.4-3.22,7.92,7.92,0,0,0-3.4,3.21l-.29.56L2.05,35.52l-.37.72a7.86,7.86,0,0,0,14.06,7l.17-.32,6.17-12.16L29.87,15.4Z",
    transform: "translate(-1 -0.71)",
    fill: "#ff5100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.15.71a7.86,7.86,0,0,0-6.87,4.05l-.17.33L63.94,17.25,56.13,32.62l5.12,10.07.28.55a7.94,7.94,0,0,0,3.41,3.23,7.94,7.94,0,0,0,3.41-3.23l.29-.55L84,12.48l.36-.73a7.86,7.86,0,0,0-7.19-11Z",
    transform: "translate(-1 -0.71)",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86,47.29a7.86,7.86,0,0,0,6.87-4l.17-.33,6.18-12.16,7.8-15.37L24.77,5.31l-.28-.55a8,8,0,0,0-3.42-3.23,8,8,0,0,0-3.41,3.23l-.28.55L2,35.52l-.37.73a7.86,7.86,0,0,0,7.19,11Z",
    transform: "translate(-1 -0.71)",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.85,15.34l-5.1-10-.28-.55a7.94,7.94,0,0,0-3.41-3.23A8.31,8.31,0,0,1,22.55,1a8.16,8.16,0,0,1,2-.25H35.23a7.92,7.92,0,0,1,6.86,4l.28.55L56.18,32.66l5.09,10,.28.55A8,8,0,0,0,65,46.47a8.05,8.05,0,0,1-3.47.81H50.79a7.91,7.91,0,0,1-6.85-4l-.29-.55Z",
    transform: "translate(-1 -0.71)",
    fill: "#ff8c44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98,24.53a.76.76,0,0,1,.84-.84h.6a.75.75,0,0,1,.8.84v1.94a5.75,5.75,0,0,1-.13,1.21h.07a7.43,7.43,0,0,1,6.8-4.39c4.19,0,5.66,2.38,5.66,6.53v9.89a.76.76,0,0,1-.84.84h-.63a.74.74,0,0,1-.81-.84V30.43c0-2.65-.43-5-3.68-5-3.59,0-6.4,2.95-6.4,6.88v7.4a.74.74,0,0,1-.81.84h-.63a.76.76,0,0,1-.84-.84Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.89,30.23h1v-.54c0-3.25-1.78-4.36-4.16-4.36a8,8,0,0,0-4.09,1.18.79.79,0,0,1-1.13-.27l-.21-.34a.76.76,0,0,1,.24-1.14,10.34,10.34,0,0,1,5.36-1.47c4,0,6.27,2.24,6.27,6.47v10a.74.74,0,0,1-.81.84h-.53a.75.75,0,0,1-.84-.84V38.37a7.14,7.14,0,0,1,.1-1.27H126A6.25,6.25,0,0,1,120.3,41c-2.85,0-5.7-1.67-5.7-4.92C114.6,30.53,121.64,30.23,124.89,30.23ZM120.7,39c3.25,0,5.16-3.35,5.16-6.3v-.8h-.94c-2.65,0-8,.1-8,3.88C116.94,37.4,118.19,39,120.7,39Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.39,24.53a.76.76,0,0,1,.84-.84h.6a.75.75,0,0,1,.8.84v1.94a5.75,5.75,0,0,1-.13,1.21h.07a7.15,7.15,0,0,1,6.2-4.39c3.11,0,4.72,1.44,5.19,4.22H145a7.16,7.16,0,0,1,6.2-4.22c4.09,0,5.59,2.38,5.59,6.53v9.89a.76.76,0,0,1-.83.84h-.61a.76.76,0,0,1-.84-.84V30.39c0-2.74-.56-5-3.61-5-3.39,0-5.67,3.55-5.67,7v7.3a.73.73,0,0,1-.8.84h-.64a.76.76,0,0,1-.84-.84V30.39c0-2.54-.37-5-3.55-5-3.42,0-5.76,3.62-5.76,7v7.3a.74.74,0,0,1-.81.84h-.63a.76.76,0,0,1-.84-.84Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.28,23.29c4.49,0,7,3.25,7,8a.84.84,0,0,1-.88.84H161.31c.1,4.29,3.05,6.74,6.54,6.74a7.17,7.17,0,0,0,4.42-1.55.7.7,0,0,1,1.11.2l.27.41a.78.78,0,0,1-.24,1.1A9.51,9.51,0,0,1,167.78,41,8.51,8.51,0,0,1,159,32.14C159,26.61,162.72,23.29,167.28,23.29ZM172,30.46c-.14-3.55-2.28-5.3-4.8-5.3a5.82,5.82,0,0,0-5.8,5.3Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185.17,23.29a8.84,8.84,0,0,1,5.6,1.91.72.72,0,0,1,.1,1.14l-.23.37c-.3.47-.67.47-1.14.17a7,7,0,0,0-4.26-1.55,6.5,6.5,0,0,0-6.57,6.81,6.5,6.5,0,0,0,6.6,6.77A7.35,7.35,0,0,0,190,37.13a.67.67,0,0,1,1.11.2l.23.34a.8.8,0,0,1-.2,1.13,9.32,9.32,0,0,1-6,2.15,8.53,8.53,0,0,1-8.84-8.81A8.59,8.59,0,0,1,185.17,23.29Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M193.65,17.83a.73.73,0,0,1,.8-.84h.64a.76.76,0,0,1,.84.84v8.41a7.18,7.18,0,0,1-.13,1.37h.06a7.43,7.43,0,0,1,6.74-4.32c4.19,0,5.66,2.38,5.66,6.53v9.89c0,.54-.26.84-.8.84h-.64a.76.76,0,0,1-.84-.84V30.43c0-2.65-.4-5-3.68-5-3.55,0-6.37,2.92-6.37,7v7.3a.76.76,0,0,1-.84.84h-.64a.73.73,0,0,1-.8-.84Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M218.75,23.29c4.49,0,7,3.25,7,8a.84.84,0,0,1-.87.84H212.79c.1,4.29,3.05,6.74,6.53,6.74a7.2,7.2,0,0,0,4.43-1.55.69.69,0,0,1,1.1.2l.27.41a.78.78,0,0,1-.23,1.1A9.57,9.57,0,0,1,219.26,41a8.52,8.52,0,0,1-8.82-8.81C210.44,26.61,214.19,23.29,218.75,23.29Zm4.73,7.17c-.13-3.55-2.28-5.3-4.8-5.3a5.8,5.8,0,0,0-5.79,5.3Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M237.12,30.23h1v-.54c0-3.25-1.78-4.36-4.16-4.36a7.85,7.85,0,0,0-4.08,1.18.8.8,0,0,1-1.14-.27l-.2-.34a.76.76,0,0,1,.23-1.14,10.34,10.34,0,0,1,5.36-1.47c4,0,6.27,2.24,6.27,6.47v10a.74.74,0,0,1-.81.84H239a.75.75,0,0,1-.84-.84V38.37a7.14,7.14,0,0,1,.1-1.27h-.07A6.25,6.25,0,0,1,232.53,41c-2.85,0-5.7-1.67-5.7-4.92C226.83,30.53,233.87,30.23,237.12,30.23ZM232.93,39c3.25,0,5.16-3.35,5.16-6.3v-.8h-.94c-2.65,0-8,.1-8,3.88C229.17,37.4,230.41,39,232.93,39Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.65,24.53a.74.74,0,0,1,.81-.84H245a.72.72,0,0,1,.81.77v1.21a6,6,0,0,1-.1,1.14h.06a6.28,6.28,0,0,1,5.9-3.52c4.53,0,7.34,3.62,7.34,8.85S255.82,41,251.43,41a6.13,6.13,0,0,1-5.57-3.42h-.06a7.84,7.84,0,0,1,.13,1.48v7.4a.76.76,0,0,1-.84.84h-.63a.74.74,0,0,1-.81-.84Zm7.54,14.38c3,0,5.47-2.48,5.47-6.77,0-4.13-2.22-6.77-5.33-6.77-2.82,0-5.47,2-5.47,6.8C245.86,35.55,247.74,38.91,251.19,38.91Z",
    transform: "translate(-1 -0.71)",
    fill: "#6e6f71"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoNamecheap, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-namecheap.7386eb4e.svg";
export { ForwardRef as ReactComponent };